import { render, staticRenderFns } from "./HelpSideBar.vue?vue&type=template&id=67a120b5&scoped=true&"
import script from "./HelpSideBar.vue?vue&type=script&lang=js&"
export * from "./HelpSideBar.vue?vue&type=script&lang=js&"
import style0 from "./HelpSideBar.vue?vue&type=style&index=0&id=67a120b5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a120b5",
  null
  
)

export default component.exports